// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"d2920531","88":"e4cd0ed3","237":"f8425dbc","289":"27a21bf9","302":"2970b65c","357":"8215f02d","381":"20be3f08","428":"7de76d98","613":"99836f10","677":"78a6b8d9","975":"b5d82d87"}[chunkId] + ".chunk.js";
};